import React from "react";
import { Row } from "react-bootstrap";
import classes from "./TabMainRow.module.css";

const TabMainRow = (props) => (
  <Row className={classes.mainRow}>{props.children}</Row>
);

export default TabMainRow;
